import { createSlice } from '@reduxjs/toolkit';
import { CommonState } from '@app/store/slices/common/commonTypes';

const initialState: CommonState = {
  isPredictionModalOpen: false,
};

const commonSlice = createSlice({
  name: 'tutorial',
  initialState,
  reducers: {
    setIsPredictionModalOpen(state, action) {
      state.isPredictionModalOpen = action.payload ? true : false;
    },
  },
});

export const commonActions = commonSlice.actions;
export const commonReducer = commonSlice.reducer;
